export const ADDRESS_LINE_MAX_LENGTH = 35;
export const COMPANY_MAX_LENGTH = 35;
export const FIRSTNAME_MAX_LENGTH = 15;
export const LASTNAME_MAX_LENGTH = 20;
